













import { computed, defineComponent, inject, onBeforeUnmount, onMounted, PropType, ref } from "@vue/composition-api";
import { Call } from "@scrile/api-provider/dist/api/CallsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import AudioPlayer from "@/lib/audioPlayer";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import { PROVIDED_DATA, PROVIDED_DATA_KEY } from "@/const";
import AvatarDescription from "@/components/AvatarDescription";
import BaseButton from "@/components/BaseButton";
import BaseCloser from "@/components/BaseCloser";

export default defineComponent({
  name: "CallNotification",
  components: { AvatarDescription, BaseButton, BaseCloser },
  props: {
    opponentUser: { type: Object as PropType<UserPublicData>, required: true },
    opponentSubscriptionStatus: { type: String as PropType<"follower" | "subscriber" | "user">, required: true },
    call: { type: Object as PropType<Call | null> },
  },
  setup(props, { emit }) {
    const callPrice = inject<PROVIDED_DATA[PROVIDED_DATA_KEY.PAID_CALL_PRICE]>(
      PROVIDED_DATA_KEY.PAID_CALL_PRICE,
      ref(0)
    );
    const loading = ref(false);

    const description = computed(() => {
      const status = props.opponentSubscriptionStatus;
      if (callPrice.value > 0) {
        let fromText = status !== "user" ? $t("from your {0}", [$t(status)]) : "";
        return $t("Paid call {0}", [fromText]);
      } else if (status !== "user") return $t("Your {0}", [$t(status)]);
      return "";
    });

    const declineHandler = () => {
      loading.value = true;
      emit("decline");
    };

    onMounted(() => {
      try {
        AudioPlayer.play("ring", { loop: true });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
      }
    });

    onBeforeUnmount(() => {
      AudioPlayer.stop("ring");
    });

    return {
      loading,
      description,
      getProfileUrl,
      declineHandler,
    };
  },
});
